import './OxylinkMessage.scss';

import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
	MessageFactory,
	MessageProps,
} from '../../../../../libs/IdeLink.Web.Common/src/modules/Auth/Pages/components/Message/Message';

const OxylinkMessage = ({ className = '' }: MessageProps) => {
	return (
		<span className={classNames({ 'OxylinkMessage-label': true, [className]: className })}>
			<FormattedMessage id="login.welcome" values={{ br: <br /> }} />
		</span>
	);
};

export const overrideOxylinkMessage = () => MessageFactory.register('**', OxylinkMessage);
